import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-800 text-white py-6">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <p className="text-center md:text-left">
              &copy; {currentYear} Face Detector AI. All rights reserved.
            </p>
          </div>
          
        </div>
        <div className="mt-4 text-center text-sm text-gray-400">
          <p>
            This application uses TensorFlow.js for face detection and analysis.
            No images are stored on servers and all processing is done in your browser.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;